import _extends from "@babel/runtime/helpers/extends";
import { BLOCK, COL, GRID, P, SECTION } from "../util/const";
import { hasCnLayoutPage } from "../util/util";
export function getObjectSetterSnippet(config) {
  var _ref = config || {},
    items = _ref.items,
    initialValue = _ref.initialValue;
  var temp = {
    componentName: 'ObjectSetter',
    props: {
      config: {
        items: items
      }
    }
  };
  if (initialValue) {
    temp.initialValue = initialValue;
  }
  return temp;
}
export function getArraySetterSnippet(config) {
  var _ref2 = config || {},
    initialValue = _ref2.initialValue,
    configure = _ref2.configure;
  return {
    componentName: 'ArraySetter',
    props: {
      mode: 'list',
      itemSetter: {
        componentName: 'ObjectSetter',
        initialValue: initialValue,
        props: {
          config: {
            items: configure
          }
        }
      }
    }
  };
}
export var createBlockInitialChildrenSnippet = function createBlockInitialChildrenSnippet(defaultCardType) {
  if (defaultCardType === 'Blank') {
    return createCellSnippet();
  } else if (defaultCardType === 'CnTile') {
    return {
      componentName: defaultCardType,
      title: '瓷片',
      props: {
        "isCnTile": true,
        "_context": {
          "type": "JSExpression",
          "value": "this"
        },
        "title": ""
      },
      children: [createCellSnippet()]
    };
  } else {
    return {
      componentName: 'CnCard',
      title: '卡片',
      props: {
        "isCnCard": true,
        "_context": {
          "type": "JSExpression",
          "value": "this"
        },
        "title": "",
        "extra": {
          "subCardList": [{
            "key": "subcard",
            "subTitle": ""
          }]
        }
      },
      children: [{
        "componentName": "CnCardSubCard",
        "title": "",
        "props": {
          "key": "subcard",
          "subTitle": ""
        },
        "children": [createCellSnippet()]
      }]
    };
  }
};
export var createBlockSnippet = function createBlockSnippet(_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
    blockProps = _ref3.blockProps,
    defaultCardType = _ref3.defaultCardType;
  return {
    componentName: BLOCK,
    title: '块',
    props: _extends({}, blockProps),
    children: [createBlockInitialChildrenSnippet(defaultCardType)]
  };
};
export var createGridlSnippet = function createGridlSnippet() {
  return {
    componentName: GRID,
    title: '网格容器',
    props: {
      rows: 2,
      cols: 2
    },
    children: []
  };
};
export var createRowColSnippet = function createRowColSnippet(componentName) {
  if (componentName === void 0) {
    componentName = COL;
  }
  return {
    componentName: componentName,
    title: componentName === COL ? '列容器' : '行容器',
    props: {},
    children: []
  };
};
export function createSectionInitialChildren() {
  var defaultCardType = hasCnLayoutPage() ? 'CnTile' : 'CnCard';
  return [createBlockSnippet({
    blockProps: {
      span: 6
    },
    defaultCardType: defaultCardType
  }), createBlockSnippet({
    blockProps: {
      span: 6
    },
    defaultCardType: defaultCardType
  })];
}
export var createPSnippet = function createPSnippet() {
  return {
    componentName: P,
    title: '段落',
    props: {},
    children: []
  };
};
export var createSectionSnippet = function createSectionSnippet(_temp2) {
  var _ref4 = _temp2 === void 0 ? {} : _temp2,
    blockProps = _ref4.blockProps;
  return {
    componentName: SECTION,
    title: '自由布局容器',
    props: {},
    children: [createBlockSnippet({
      blockProps: blockProps
    })]
  };
};
export var createAsideSnippet = function createAsideSnippet() {
  return {
    componentName: 'CnLayoutAside',
    title: '侧边栏',
    props: {},
    children: [createCellSnippet(createSectionSnippet())]
  };
};
export var createFooterSnippet = function createFooterSnippet() {
  return {
    componentName: 'CnLayoutFooter',
    title: '页尾',
    props: {},
    children: [createCellSnippet()]
  };
};
export var createCellSnippet = function createCellSnippet(children) {
  return {
    componentName: 'CnLayoutCell',
    title: '容器',
    props: {},
    children: children || []
  };
};
export function createHeaderSnippet() {
  return {
    componentName: 'CnLayoutHeader',
    title: '页头',
    props: {},
    children: [createCellSnippet()]
  };
}
;
export function getComponentSlotSetterSnippet(config) {
  var _ref5 = config || {},
    title = _ref5.title,
    slotInitialValue = _ref5.slotInitialValue;
  return {
    name: 'componentSlot',
    title: title || '开启筛选栏插槽',
    setter: {
      componentName: "SlotSetter",
      title: "组件坑位",
      initialValue: slotInitialValue || {
        type: "JSSlot",
        value: [createDefaultFilter()]
      }
    },
    extraProps: {
      getValue: function getValue(target, value) {
        if (value && (value === null || value === void 0 ? void 0 : value.type) === 'JSSlot') {
          return value;
        } else if (value === undefined || value === null) {
          return '';
        } else {
          return {
            type: "JSSlot",
            value: [{
              componentName: "CnFilter",
              props: {
                title: '布局容器的筛选栏'
              }
            }]
          };
        }
      }
    }
  };
}
export function createDefaultFilter() {
  return {
    componentName: "CnFilter",
    props: {
      title: '瓷片筛选栏',
      filterStyle: {
        showFolder: false,
        showSelected: false,
        enableConfig: false,
        showBottomLine: false,
        hideButton: true,
        removeEmptyLabel: true,
        size: 'small',
        maxVisibleRow: 999
      },
      mobileProps: {
        positionFix: false
      },
      className: 'l2-cn-filter-in-chart',
      config: [{
        "label": "",
        "name": "radio",
        "componentName": "RadioGroup",
        "options": {
          "extra": {
            "direction": "hoz",
            "type": "button"
          },
          "dataSource": [{
            "label": "选项1",
            "value": "radio1"
          }, {
            "label": "选项2",
            "value": "radio2"
          }],
          "dataOrigin": "static"
        }
      }]
    }
  };
}
export function getGroupSetterSnippet(config) {
  var _ref6 = config || {},
    outerConfig = _ref6.outerConfig,
    items = _ref6.items;
  return _extends({
    type: 'group',
    title: '分组',
    // extraProps: {
    //   display: 'block',
    // },
    display: 'accordion',
    items: items
  }, outerConfig);
}
export function getMixedSetterSnippet(config) {
  var _ref7 = config || {},
    setters = _ref7.setters;
  return {
    componentName: 'MixedSetter',
    props: {
      setters: setters
    }
  };
}